import SelectionTable from "lib/common/selectiontable/SelectionTable";
import PropTypes from "prop-types";
import React from "react";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";

export default class SearchResults extends React.Component {
    render() {
        const { isLoading, records = [], onPage, pagination } = this.props;
        const indexZeroPage = pagination.page - 1;
        return (
            <div className="search-results-container">
                {isLoading && <div className="local-over-modal"><img src="images/waiting.svg" alt="Loading..." /></div>}
                <SelectionTable {...this.props} fixedHeaders={true} />
                {
                    (
                        // Only show pagination controls when there are
                        // multiple pages or we are on a page other then 1.
                        records.length >= pagination.pageSize ||
                        pagination.page > 1
                    ) && (
                        <div className="row search-pagination">
                            <div className="col-sm-6">
                                <div className="search-pagination-summary">
                                    Showing results {indexZeroPage * pagination.pageSize + 1} to {indexZeroPage * pagination.pageSize + records.length}
                                </div>
                            </div>
                            <div className="col-sm-6 text-right">
                                <div className="search-pagination-buttons">
                                    <Button
                                        enabled={pagination.page > 1}
                                        onClick={() => onPage(pagination.page - 1)}
                                        label={"<"}
                                    />
                                    <strong> Page {pagination.page} </strong>
                                    <Button
                                        enabled={records.length >= pagination.pageSize}
                                        onClick={() => onPage(pagination.page + 1)}
                                        label={">"}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
}

SearchResults.propTypes = {
    isLoading: PropTypes.bool,
    records: PropTypes.array,
    selectedRecord: PropTypes.object,
    columns: PropTypes.array,
    supportsEnablement: PropTypes.bool,
    sorts: PropTypes.object,
    onSort: PropTypes.func.isRequired,
    onRecordSelection: PropTypes.func.isRequired,
    showDisabled: PropTypes.bool,
    maxHeight: PropTypes.string,
    onPage: PropTypes.func,
    pagination: PropTypes.shape({
        page: PropTypes.number,
        pageCount: PropTypes.number,
        pageSize: PropTypes.number,
        totalResultCount: PropTypes.number
    }).isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/search/views/SearchResults.js